import { useRouter } from "next/router";
import { useEffect, useContext } from "react";
import { PageTitle } from "@/components/molecules";
import { ErrorWords } from "@/components/organisms/ErrorWords";
import { MainTemplate } from "@/components/templates";
import { AuthContext, AuthStatus } from "@/contexts/AuthContext";

export const AcceptCompanyWithdrawalCompletedPage = () => {
  const router = useRouter();
  const { signOut, authStatus } = useContext(AuthContext);

  useEffect(() => {
    if (authStatus != AuthStatus.SignedOut) {
      signOut();
      return;
    }
  });

  return (
    <MainTemplate
      title={`Mikatano シリーズ退会手続き`}
      disableAccountDropDown={true}
    >
      <PageTitle
        mainTitle={`Mikatano シリーズ退会手続き`}
        subTitle={`Mikatano シリーズすべてのサービスの利用を終了しました。`}
      />
      <ErrorWords textAlign="left">
        <>
          退会が完了しました。
          <br />
          ご利用いただき、ありがとうございました。
        </>
      </ErrorWords>
    </MainTemplate>
  );
};
